module.exports = __webpack_public_path__ + "img/产品推荐1760-800.8e9fd362.jpg";